module.exports = __webpack_public_path__ + "static/img/logo4.6d25fdf0.png";